/**
 * The querystring the list endpoint is asked for.
 *
 * `count=100` is the endpoint's own ceiling (`PAGINATION.maxCount`) and the
 * table holds 14 seeded rows, so this is the full set with room to spare.
 * Fetching it whole is what lets the table sort and filter every column: the
 * endpoint's `sort` enum covers only `name`, `description` and `updatedAt`, it
 * filters `name` alone, and its `q` search param is unreachable behind an
 * `additionalProperties: false` querystring that rejects it.
 *
 * `page` is 0-based — the handler does `OFFSET page * count` with no
 * adjustment of its own.
 */
export function buildProductionProcessesQs(): string {
  const qs = new URLSearchParams();
  qs.set('page', '0');
  qs.set('count', '100');
  return qs.toString();
}
